"use strict";

exports.__esModule = true;
exports.isImageCard = void 0;
var isImageCard = function isImageCard(columns) {
  return columns.find(function (item) {
    if (!item) return false;
    var description = item.description,
      image = item.image;
    if (!description) return false;
    var mainHeading = description.mainHeading,
      paragraph = description.paragraph,
      sectionHeading = description.sectionHeading;
    return image && !mainHeading && !paragraph && !sectionHeading;
  });
};
exports.isImageCard = isImageCard;